module.exports = __webpack_public_path__ + "img/red-rectangle-table-4.b8fa1238.png";